export const FETCH_PAGE_TYPES = "pagetypes/FETCH_PAGE_TYPES";
export const FETCH_PAGE_TYPES_SUCCESS = "pagetypes/FETCH_PAGE_TYPES_SUCCESS";
